export default {
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    option: {
      type: Object,
      default: () => ({})
    },
    isValidator: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    val: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    getRules () {
      const { isRequired, isInputLimit, inputLimit, rules, isOtherOption, isOtherOptionRequired } = this.option
      let formItemRules = []
      if (isRequired) {
        formItemRules.push(this.$rules.required())
      }
      if (isInputLimit && inputLimit) {
        formItemRules.push(this.$rules[inputLimit]())
      }
      if (rules instanceof Array && rules.length) {
        rules.forEach(r => {
          const { rule, params = [] } = r
          if (rule) formItemRules.push(this.$rules[rule](...params))
        })
      }
      if (isOtherOption && isOtherOptionRequired) {
        formItemRules.push({
          validator: this.otherOptionValidator,
          trigger: ['blur', 'change']
        })
      }
      return formItemRules
    },
    getOptions () {
      return this.option.options
    }
  },
  methods: {
    otherOptionValidator (rule, value, callback) {
      if (value && value.value === this.option.otherOption.value) {
        if (value.otherValue) {
          callback()
        } else {
          callback(new Error('请输入其他选项'))
        }
      } else {
        callback()
      }
    }
  }
}
